import { IconComponentsProps } from './types';

const VerticalDotsIcon = ({ fill = 'currentColor', ...props }: IconComponentsProps) => (
  <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.08301 14.1943C3.06197 14.1943 3.85643 14.9697 3.85645 15.9258C3.85645 16.8818 3.06197 17.6572 2.08301 17.6572C1.10425 17.657 0.310547 16.8817 0.310547 15.9258C0.310557 14.9699 1.10425 14.1946 2.08301 14.1943ZM2.08301 7.27051C3.06197 7.27051 3.85645 8.04591 3.85645 9.00195C3.85621 9.95781 3.06183 10.7324 2.08301 10.7324C1.10439 10.7322 0.310777 9.95766 0.310547 9.00195C0.310547 8.04605 1.10425 7.27074 2.08301 7.27051ZM2.08301 0.345703C3.06195 0.345703 3.85641 1.12113 3.85645 2.07715C3.85645 3.0332 3.06197 3.80859 2.08301 3.80859C1.10425 3.80836 0.310547 3.03305 0.310547 2.07715C0.310582 1.12128 1.10427 0.34594 2.08301 0.345703Z"
      fill={fill}
    />
  </svg>
);

export default VerticalDotsIcon;
